<template>
  <ClearableInput
    v-bind="$attrs"
    :model-value="modelValue"
    :mask="mask"
    placeholder="BA 2273"
    @focus="$emit('focus')"
    @update:modelValue="$emit('update:modelValue', $event)"
    @paste.prevent="onPaste"
  >
    <template #prepend>
      <q-icon
        color="black"
        name="flight_land"
        :size="iconSize"
      />
    </template>
  </ClearableInput>
</template>

<script setup>
import { nextTick, ref, watch } from 'vue';
import ClearableInput from '~components/ClearableInput';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  iconSize: {
    type: String,
    default: 'sm',
  },
});

defineOptions({
  inheritAttrs: false,
});

const emit = defineEmits(['update:modelValue', 'focus']);

const mask = ref('XX ####');

function toggleNumberMask(value) {
  // EasyJet use ICAO format
  if (['EZ', 'EJ'].some((prefix) => value?.startsWith(prefix))) {
    mask.value = 'XXX ####';
  } else {
    mask.value = 'XX ####';
  }
}

function onPaste(event) {
  const text = event.clipboardData.getData('text/plain');
  toggleNumberMask(text);
  nextTick(() => {
    emit('update:modelValue', text);
  });
}

watch(() => props.modelValue, toggleNumberMask, { immediate: true });
</script>
